<style lang="scss" scoped src="./app-list.scss"></style>
<style lang="scss">
.app-list-page-popver {
    padding: 8px 16px;
    text-align: center;
}
</style>

<template>
    <div class="app-list" :class="[listClass]">
      <draggable element="ul" v-model="myList" class="app-flex app-flex-wrap" :options="draOpt" :move="checkMove" @end="checkEnd" @start="onStart">
        <template v-for="item in myList">
          <li  @click="goTo(item)" :key="item.appId" :title="item.drag && type === 'often' ? '拖动改变顺序' : ''" class="app-list__item app-flex app-flex-c app-flex-o" :class="{'app-list__item-disabled': !item.drag || type === 'all', 'app-list__item-all': type === 'all', 'app-list__item-often': type === 'often'}" v-if="item.show === false ? false : true">
            <img class="app-list-logo" v-lazy="item[props.logo] ? item[props.logo] : logoImg">
            <p class="app-list__item-name"><span class="recommend" v-if="type === 'all' && item.isRecommend">荐</span>{{currentLang === 'en' ? item[props.enName] : item[props.name]}}</p>
            <el-popover placement="top" title="" width="auto" trigger="hover" :content="handleType === 'add' ? $t('others.addTip') : $t('others.delTip')" popper-class="app-list-page-popver" v-if="!item.popDisabled">
              <img slot="reference" title="" class="app-list-handle" :src="handleType === 'add' ? addImg : delImg" @click.stop="handleClick(item)" v-if="item.handleShow && loginUser">
            </el-popover>
            <div class="app-list-tag" :class="{special: isShowTag(item) === '0'}" v-if="isShowTag(item)">
              <div class="app-list-tag__text" v-if="isShowTag(item) === '1'">免登录</div>
              <div class="app-list-tag__text" v-if="isShowTag(item) === '0'">域帐号</div>
            </div>
            <div class="app-list__item-info" v-if="type === 'all' && item.isRecommend">
              <p :title="currentLang === 'en' ? item[props.enName] : item[props.name]" class="title app-ellipsis">{{currentLang === 'en' ? item[props.enName] : item[props.name]}}</p>
              <div class="details">{{currentLang === 'en' ? item.enDescription : item.description}}</div>
            </div>
          </li>
        </template>
      </draggable>
    </div>
</template>
<script>
import logoImg from '@/assets/images/logo.png'
import store from './store/app-list'
import draggable from 'vuedraggable'
import addImg from './images/icon-tianjia@2x.png'
import delImg from './images/icon-yichu@2x.png'

export default {
  name: 'appList',
  model: {
    prop: 'list',
    event: 'change'
  },
  components: {
    draggable
  },
  props: {
    list: {
      type: Array,
      default () {
        return []
      }
    },
    type: {
      type: String,
      default: 'often' // often 常用 all 所有(应用市场)
    },
    handleType: {
      type: String,
      default: 'delete' // 新增或删除按钮图标
    },
    handleClick: {
      type: Function
    },
    isDrag: {
      type: Boolean,
      default: false
    },
    onDrag: {
      type: Function
    },
    onMove: {
      type: Function
    },
    props: {
      type: Object,
      default () {
        return {
          logo: 'logo',
          name: 'name',
          url: 'url',
          enName: 'enName'
        }
      }
    }
  },
  beforeCreate () {
    // 注册当前模块到Store
    if (!this.$store.state.appListStore) {
      this.$store.registerModule('appListStore', store)
    }
  },
  data () {
    return {
      addImg,
      delImg,
      logoImg,
      newWindow: '',
      currentMoveEle: '',
      listClass: '',
      draOpt: {
        ghostClass: 'app-list__item-start', // 拖拽元素class
        scroll: true,
        filter: '.app-list__item-disabled, .app-list-handle', // 禁用拖拽功能的元素class
        forceFallback: true,
        fallbackClass: 'app-list__item-drag',
        delay: 50
      }
    }
  },
  computed: {
    myList: {
      get () {
        return this.list
      },
      set (value) {
        this.$emit('change', value)
      }
    },
    loginUser () {
      return this.$store.state.global.loginInfo
    },
    currentLang () {
      return this.$i18n.locale
    }
  },
  methods: {
    /**
         * 应用访问判断
         */
    goTo (item, event) {
      if (!this.isManage(item)) {
        // 免登录应用 需要登录权限
        if (!this.loginUser) {
          this.$store.dispatch('global/domainLogin')
        } else {
          if (
            !(
              !item.businessUrl ||
              !item.managerUrl ||
              (!this.isManage(item) &&
                item.appProperty.indexOf('NOAUTH') > -1)
            )
          ) {
            // this.newWindow = window.open()
          }
          this.$store
            .dispatch('global/GET_LOGIN_STAGE')
            .then(res => {
              this.goToApp(item)
            }).catch((err) => {
              // if (this.newWindow) this.newWindow.close()
              window.close()
              if (err.code === 'user-not-login') this.$message(this.$t('others.sessionPast'))
            })
        }
      } else {
        // 有没有登录都可以访问的应用
        if (!item.appProperty.indexOf('INDEX') > -1) {
          if (
            !(
              !item.businessUrl ||
              !item.managerUrl ||
              (!this.isManage(item) &&
              item.appProperty.indexOf('NOAUTH') > -1)
            )
          ) {
            // this.newWindow = window.open()
          }
          this.goToApp(item)
        } else {
          window.open(item.managerUrl)
        }
      }
    },
    /**
         * 增加或删除事件回调
         */
    onHandle (item) {
      if (this.handleClick) this.handleClick(item)
    },
    goToApp (item) {
      if (!item.businessUrl) {
        this.$message({
          message: this.$t('error.configHome'),
          type: 'warning'
        })
      } else if (!item.managerUrl) {
        this.$message({
          message: this.$t('error.configAddress'),
          type: 'warning'
        })
      } else if (
        !this.isManage(item) &&
        item.appProperty.indexOf('NOAUTH') > -1
      ) {
        this.$message({
          message: this.$t('error.configAuth'),
          type: 'warning'
        })
      } else {
        this.getITLoginUrl(item).then(url => {
          // if (this.newWindow) this.newWindow.location.href = url
          window.open(url, '_blank')
        })
      }
    },
    /**
         * 是否显示标签
         */
    isShowTag (item) {
      if (!item.appProperty || item.appProperty.indexOf('0') > -1) {
        return '0'
      } else if (item.appProperty.indexOf('1') > -1) {
        return '1'
      } else {
        return false
      }
    },
    /**
         * 判断应用所属类型 是否
         */
    isManage (item) {
      // item.appProperty 应用标签类型(登录方式)  AD: 域账号 INDEX:无 LOGIN: 自建登录
      let arr = ['AD', 'INDEX', 'LOGIN']
      for (let i = 0; i < arr.length; i++) {
        if (item.appProperty && item.appProperty.indexOf(arr[i]) > -1) {
          return true
        }
      }
      return false
    },
    onStart () {
      this.listClass = 'is-draging' // 拖拽中 覆盖在拖拽中单元格的hover效果
    },
    /**
         * 拖拽移动时钩子
         * @return {Boolean}  判断是否可拖拽
         */
    checkMove (evt) {
      this.currentMoveEle = evt.draggedContext.element // 储存当前拖拽项
      if (this.onMove) return this.onMove(evt.draggedContext.element, evt.relatedContext.index)
      else return evt.draggedContext.element.drag || false
    },
    /**
         * 拖拽結束时钩子
         */
    checkEnd (opt) {
      this.listClass = ''
      if (opt.newIndex !== opt.oldIndex && this.onDrag) {
        this.onDrag(this.currentMoveEle, opt.newIndex, opt.oldIndex)
      }
      this.currentMoveEle = ''
    },
    /**
     * 根据登录方式不同获取相应应用访问地址
     */
    async getITLoginUrl (appInfor) {
      let ticket = this.loginUser ? this.loginUser.ticket : ''
      let url = ''
      const { managerUrl, appProperty, businessUrl } = appInfor
      if (appProperty) {
        // 无登录方式
        // if (appInfor.appProperty.indexOf('INDEX') > -1) {
        //   return appInfor.managerUrl
        // }
        if (this.isManage(appInfor)) {
          url = appInfor.managerUrl
        } else if (appProperty.indexOf('OTHERLINK') > -1) {
          // OTHERLINK 应用标签为(登录方式):免登陆自定义参数
          url = managerUrl.replace('{0}', ticket) + '&spg_id_token=' + this.loginUser.spg_id_token
        } else if (appProperty.indexOf('OTHERTOKEN') > -1) {
          // OTHERTOKEN 应用标签(登录方式)为adms方式(老的单点登录)
          const res = await this.getAdmsTicket()
          url = managerUrl.replace('{0}', res.data)
        } else if (appProperty.indexOf('IDAAS') > -1) {
          // IDAAS 应用标签为IDass
          url = managerUrl + '?access_token=' + this.loginUser.access_token + '&spg_id_token=' + this.loginUser.spg_id_token
        } else {
          // 免登陆
          url = managerUrl + '?ticket=' + ticket + '&spg_id_token=' + this.loginUser.spg_id_token + '&redirectUrl=' + businessUrl
        }
      } else {
        // 免登陆
        url = managerUrl + '?ticket=' + ticket + '&spg_id_token=' + this.loginUser.spg_id_token + '&redirectUrl=' + businessUrl
      }
      return url
    },
    getAdmsTicket () {
      return this.axios.post('/api/app/info/portal/user/adms/token')
    }
  }
}
</script>
